import { FaUsers } from 'react-icons/fa';

export const DEFAULT_MENU_ITEM_ICON = FaUsers;

// Settings lives under the account gear icon (AccountMenu), never as a
// NavMenu tab — excluded by parent so it can't collide with another
// category's decoded ABCD tab digit (see buildMenuTabs.js).
export const SETTINGS_CATEGORY = 'com.tempedge.msg.menu.settings';

// Dashboard isn't shown as its own tab — the logo already links there.
export const DASHBOARD_CATEGORY = 'com.tempedge.msg.menu.dashboard';
